<template>
  <form @submit="handleSubmit">
    <slot />
  </form>
</template>

<script setup lang="ts">
type Emits = {
  (e: 'submit', ev: Event): void
}

const emit = defineEmits<Emits>()

const handleSubmit = (ev: Event) => {
  ev.preventDefault()
  emit('submit', ev)
}
</script>
